import { useState, useEffect, useRef } from 'react';
import './ZoneSelector.scss';

import Checkbox from '../Checkbox';

const ZoneSelector = ({ handleChange, selectedZones, zoneList }) => {
  const [selectZoneList, setSelectZoneList] = useState([]);
  const [selectAllList, setSelectAllList] = useState([]);
  const [currentScrollTop, setCurrentScrollTop] = useState(0);
  const listRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (listRef.current) {
        setCurrentScrollTop(listRef.current.scrollTop);
      }
    };

    const currentListRef = listRef.current;

    if (currentListRef) {
      currentListRef.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (currentListRef) {
        currentListRef.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  useEffect(() => {
    if (selectZoneList.length === 0 && selectedZones) {
      let newSelectedZones = [];

      selectedZones.map((zone) => {
        newSelectedZones.push(zone);
        setSelectZoneList(newSelectedZones);
      });
    }
  }, [selectedZones]);

  useEffect(() => {
    handleChange(null, 'selectedZones', selectZoneList);
  }, [selectZoneList]);

  function handleZoneSelect(zone) {
    if (selectZoneList.includes(zone)) {
      // If zone is already in the list, remove it
      setSelectZoneList((prevList) => prevList.filter((item) => item !== zone));
    } else {
      // If zone is not in the list, add it
      setSelectZoneList((prevList) => [...prevList, zone]);
    }
  }

  //select all by BUILDING
  function handleSelectAll(e, building) {
    let tempZoneList = [];
    building.thermalZones.map((zone) => {
      tempZoneList.push(zone.thermalZoneEntityKey);
    });

    if (selectAllList.includes(building.buildingShortDescription)) {
      // If building is already in the list, remove it
      setSelectAllList((prevList) =>
        prevList.filter((item) => item !== building.buildingShortDescription)
      );
    } else {
      // If building is not in the list, add it
      setSelectAllList((prevList) => [...prevList, building.buildingShortDescription]);
    }

    if (e.target.checked) {
      if (selectZoneList.length === 0) {
        setSelectZoneList([...selectZoneList, ...tempZoneList]);
      } else {
        let newList = [];
        newList.push(...selectZoneList, ...tempZoneList);

        setSelectZoneList(() => newList.filter((item) => !selectZoneList.includes(item.id)));
      }
    } else {
      setSelectZoneList((prevItems) => prevItems.filter((item) => !tempZoneList.includes(item)));
    }
  }

  return (
    <div className="zone-picker">
      <div className="zone-container" ref={listRef}>
        <div className="title">
          Select Zones:{' '}
          <span>
            {selectZoneList.length === 0
              ? 'Choose one or more'
              : `${selectZoneList.length} selected`}
          </span>
        </div>

        <div className="zone-items">
          {zoneList &&
            zoneList.map((building) => (
              <div
                className={`building-${building.buildingIndex}-group-items`}
                key={building.buildingIndex}
              >
                <div className="group-container list-item">
                  <div className="group-label">{building.buildingShortDescription}</div>
                </div>

                <div className="select-all" key={`${building.buildingIndex}-select-all`}>
                  <Checkbox
                    id={`${building.buildingIndex}-select-all`}
                    name={`${building.buildingIndex}-select-all`}
                    type="checkbox"
                    onChange={(e) => handleSelectAll(e, building)}
                    checked={selectAllList.includes(building.buildingShortDescription)}
                  />
                  Select all in {building.buildingShortDescription}
                </div>

                <hr />

                {building.thermalZones.map((zone) => (
                  <div
                    className="zone-item list-item"
                    key={zone.thermalZoneEntityKey}
                    onClick={() => handleZoneSelect(zone.thermalZoneEntityKey)}
                  >
                    <input
                      id={zone.thermalZoneEntityKey}
                      type="checkbox"
                      checked={selectZoneList.includes(zone.thermalZoneEntityKey)}
                      onChange={() => handleZoneSelect(zone.thermalZoneEntityKey)}
                    />
                    <span className="zone-checkmark"></span>

                    {zone.thermalZoneShortDescription}
                  </div>
                ))}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default ZoneSelector;
